import React from "react"
import { navigate } from "gatsby"
import styled from "@emotion/styled"
import { connect } from "react-redux"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import ArrowLeft from "-!svg-react-loader!../../assets/icons/arrow-left.svg"

import { getPreviousSection } from "../../utils/nextorprevquestionsectionlogic"

import {
  decrementProgress,
  setProgress,
  setCurrentSection,
  unendQuizEarly,
  decrementTotalProgress,
  toggleMovingForward,
  decrementMirrorProgress,
} from "../../actions"

import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

const PreviousButton = styled.button`
  border-bottom: 1px solid ${theme.wild.color.master.base.black};
  font-size: 12px;
  line-height: 12px;
  height: 14px;
  ${queries.medium`
    font-size: 14px;
    line-height: 14px;
    height: 17px;
  `}
  ${queries.large`
    font-size: 16px;
    line-height: 20px;
    height: 21px;
  `}
`
const SVGWrap = styled.span`
  display: inline-block;
  vertical-align: middle;
  transform: translate(-3px, -1px);
  svg {
    width: 14px;
    height: 14px;
    ${queries.medium`
      width: 16px;
      height: 16px;
    `}
  }
`
const TextWrap = styled.span`
  display: inline-block;
  color: ${theme.wild.color.master.base.black};
  margin-left: 3px;
`

const PrevButton = (props) => {
  const { quizProgress, currentSection, currentQuestionId, quizData } = props

  const goToPreviousStep = () => {
    let decrementNum = "hairToday" === currentQuestionId ? 2 : 1

    if (quizProgress > 0) {
      let prevStepNum = parseInt(props.quizProgress) - decrementNum
      props.decrementProgress(prevStepNum)
      if (typeof window !== `undefined`) {
        sessionStorage.setItem("quizProgress", prevStepNum)
      }
    }
  }

  const setSection = (name) => {
    props.setCurrentSection(name)
    if (typeof window !== `undefined`) {
      sessionStorage.setItem("currentSection", name)
    }
  }

  const resetProgress = (prog) => {
    props.setProgress(prog)
    if (typeof window !== `undefined`) {
      sessionStorage.setItem("quizProgress", prog)
    }
  }

  const goToPreviousSection = () => {
    let prevStepSection = getPreviousSection(currentSection)
    let prevStepUrl = `/${prevStepSection}/`
    navigate("/step" + prevStepUrl)
    setSection(prevStepSection)

    if (props.sectionLengthStarter[prevStepSection + "length"]) {
      let prevSectionLength =
        props.sectionLengthStarter[prevStepSection + "length"]
      resetProgress(prevSectionLength)
    } else {
      resetProgress(0)
    }
  }

  const getPrevQuestion = (currentSectionData) => {
    let prevQuestion = {}
    if (quizProgress === 0) {
      const prevStepSection = getPreviousSection(currentSection)
      const prevSectionData = quizData?.sections?.filter(
        (section) => section.path === prevStepSection
      )[0]
      prevQuestion =
        prevSectionData?.questions[prevSectionData.questions.length - 1]
    } else {
      const currentQuestionIndex = currentSectionData?.questions?.findIndex(
        (question) => question.id === currentQuestionId
      )
      prevQuestion = currentSectionData?.questions[currentQuestionIndex - 1]
    }
    return prevQuestion
  }

  const trackBackButtonClick = () => {
    const currentSectionData = quizData?.sections?.filter(
      (section) => section.path === currentSection
    )[0]
    const currentQuestion = currentSectionData?.questions?.filter(
      (question) => question.id === currentQuestionId
    )[0]
    const prevQuestion = getPrevQuestion(currentSectionData)
    segmentEvent("Quiz Clicked Back", {
      back_to_question: prevQuestion?.text,
      back_to_question_id: prevQuestion?.id,
      initial_question: currentQuestion?.text,
      initial_question_id: currentQuestion?.id,
      section_name: currentSection?.name,
    })
  }

  const progressBarPrevStep = () => {
    if (quizProgress > 0) {
      let prevStepNum = parseInt(props.quizProgress) - 1
      props.decrementMirrorProgress(prevStepNum)
    }
  }

  const prevQuestionOrSection = () => {
    if (props.updateMounted) {
      props.updateMounted(false)
    }

    if (props.triggerGlobalUnmount) {
      props.triggerGlobalUnmount(true)
      setTimeout(() => {
        props.triggerGlobalUnmount(false)
      }, 2001)
    }

    props.toggleMovingForward(false)

    if (quizProgress !== 0) {
      progressBarPrevStep()
    }

    if (props.currentSection === "basics" && quizProgress === 0) {
      props.setProgress(0)
      if (
        document.referrer.indexOf(
          `${process.env.GATSBY_MAGENTO_URL}hair/men/quiz`
        ) === 0
      ) {
        return setTimeout(
          () =>
            (window.location.href = `${process.env.GATSBY_MAGENTO_URL}hair/men/quiz/`),
          100
        )
      } else {
        return setTimeout(() => navigate("/"), 501)
      }
    }

    setTimeout(() => {
      quizProgress === 0 ? goToPreviousSection() : goToPreviousStep()
      trackBackButtonClick()
    }, 350)
  }

  return (
    <>
      <PreviousButton onClick={prevQuestionOrSection}>
        <SVGWrap>
          <ArrowLeft />
        </SVGWrap>
        <TextWrap className="font-dinamoRegular">{`Previous`}</TextWrap>
      </PreviousButton>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    quizProgress: state.progressReducer.quizProgress,
    currentSection: state.sectionReducer.currentSection,
    sectionLength: state.sectionLengthReducer.sectionLength,
    sectionLengthStarter: state.dynamicSectionLengthReducer,
    endQuizEarly: state.progressReducer.endQuizEarly,
    currentQuestionId: state.questionIdReducer.currentQuestionId,
    isFinasteride: state.setIsFinasterideMinoxidilReducer.isFinasteride,
    isMinoxidil: state.setIsFinasterideMinoxidilReducer.isMinoxidil,
  }
}

export default connect(mapStateToProps, {
  setProgress,
  decrementProgress,
  setCurrentSection,
  unendQuizEarly,
  decrementTotalProgress,
  toggleMovingForward,
  decrementMirrorProgress,
})(PrevButton)
